import { useAllPartySupMasts } from "http-hooks/partysupmast/usepartysupmast";
import DeleteGroup from "components/groups/DeleteGroup";
import { useState } from "react";
import useModalStore from "store/modals";
import { formatDateAndTime } from "utils/date";
import InputSearch from "components/ui/InputSearch";
import Select from "components/ui/Select";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const typeOptions = [
  { value: "", label: "All Types" },
  { value: "V", label: "Vendor" },
  { value: "C", label: "Customer" },
];

const initialFilter = {
  name: "",
  grpId: "",
  type: "",
  page: 1,
  limit: 10,
};

const getTypeLabel = (type) => {
  switch (type) {
    case "V":
      return "Vendor";
    case "C":
      return "Customer";
    default:
      return type;
  }
};

const columns = [
  { key: "grpId", header: "Group Code" },
  {
    key: "name",
    header: "Group Name",
    render: (item) => <div className="font-medium">{item.name}</div>,
  },
  {
    key: "type",
    header: "Type",
    render: (item) => getTypeLabel(item.type),
  },
  {
    key: "gendt",
    header: "Created Date",
    render: (item) => formatDateAndTime(item.gendt),
  },
  { key: "actions", header: "Actions", isActions: true },
];

export default function GroupMaster() {
  const [selectedType, setSelectedType] = useState(null);
  const [filter, setFilter] = useState(initialFilter);
  const [searchName, setSearchName] = useState("");
  const [searchCode, setSearchCode] = useState("");
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("group", id);

  const handleTypeChange = (type) => {
    setSelectedType(type);
    setFilter((prev) => ({ ...prev, type: type?.value || "" }));
  };

  const handleNameSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, name: searchTerm }));
  };

  const handleCodeSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, grpId: searchTerm }));
  };

  const clearFilters = () => {
    setSelectedType(null);
    setSearchName("");
    setSearchCode("");
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allgroups, page: currentPage, totalPages } = [],
  } = useAllPartySupMasts({ ...filter, level: 1 });

  return (
    <MasterPage
      title="Vend/Cust Groups"
      headerActions={
        <AddButton onClick={() => openSetModal()}>
          Add Vend/Cust Group
        </AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              onSearch={handleNameSearch}
              label="Group Name"
              placeholder="Search by group name"
            />
          </FilterCell>
          <FilterCell>
            <InputSearch
              value={searchCode}
              onChange={(e) => setSearchCode(e.target.value)}
              onSearch={handleCodeSearch}
              label="Group Code"
              placeholder="Search by group code"
            />
          </FilterCell>
          <FilterCell>
            <Select
              options={typeOptions}
              value={selectedType}
              onChange={handleTypeChange}
              label="Type"
              placeholder="Select Type"
              isClearable
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allgroups}
      isLoading={isLoading}
      rowKey="ps_Id"
      deleteComponent={DeleteGroup}
      renderActions={(item, setDeleteItemId) => (
        <>
          <EditAction
            onClick={() => openSetModal(item.ps_Id)}
            title="Edit Group"
            variant="secondary"
          />
          <DeleteAction
            onClick={() => setDeleteItemId(item.ps_Id)}
            title="Delete Group"
          />
        </>
      )}
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
